

import React, { memo, useMemo } from 'react';
import { Text } from '../../../../ui-kit';

import './styles/_splash-details.scss';






const ElevateList = (props) => {
  const { splashRelations, isMobile = false } = props;
  const displayLength = isMobile ? 1 : 2;
  const templateNames = useMemo(() => {
    if (splashRelations.length) {
      const templates = splashRelations.map((template) => template.PitchTemplate.templateName);
      if (templates.length) {
        const list = templates.splice(0, displayLength);
        const displayTemplateNames = list.join(', ');
        let remainingTemplates = '';
        if (templates.length > 0) {
          remainingTemplates = `, +${templates.length} more`;
        }
        return {
          displayTemplateNames,
          remainingTemplates
        };
      }
    }
    return {};
  }, [splashRelations, displayLength]);

  return (
    <div className="splash-page-data-table__link-elevate">
      {templateNames.displayTemplateNames ?
      <div className="splash-page-data-table__link-elevate__list">
          <Text
          prefixIcon="link"
          success
          highlighted>

            {templateNames.displayTemplateNames}
          </Text>
          {templateNames.remainingTemplates &&
        <Text>
              {templateNames.remainingTemplates}
            </Text>}

        </div> :

      <Text
        prefixIcon="link"
        disabled
        className="splash-page-data-table__link-elevate__no-elevate">

          Not linked to any Elevate templates
        </Text>}

    </div>);

};

export default memo(ElevateList);